import { Controller } from '@hotwired/stimulus'

// Namespaced collapse events bound by focusToggle, kept separate from the ones select_controller binds
const FOCUS_EVENTS = 'shown.bs.collapse.collapsedForm hidden.bs.collapse.collapsedForm'

/**
 * Allows a form to be displayed within a collapsable panel.
 *
 * The focusToggle event will display a form with the referenced element selected.
 */
export default class extends Controller {
  static classes = ['active', 'collapse']
  static targets = ['content', 'toggleButton']

  connect () {
    const $contentTarget = $(this.contentTarget)

    $contentTarget.on('show.bs.collapse', () => {
      $(this.toggleButtonTarget).addClass(this.activeClass)
    })

    $contentTarget.on('hide.bs.collapse', () => {
      $(this.toggleButtonTarget).removeClass(this.activeClass)
    })

    // NOTE: hiding using html prevents select2 from working
    setTimeout(() => {
      $contentTarget.addClass(this.collapseClass)
    }, 0)
  }

  toggle (event) {
    $(this.contentTarget).collapse('toggle')
  }

  focusToggle (event) {
    const $contentTarget = $(this.contentTarget)
    const $clickTarget = $(this.element).find('#' + event.params.target)

    // Namespaced so we only unbind our own handlers, leaving the deferred select2 setup intact
    $contentTarget.off(FOCUS_EVENTS).on('shown.bs.collapse.collapsedForm', () => {
      if ($clickTarget.data('select2')) {
        $clickTarget.select2('open') // select2 input
      } else {
        $clickTarget.trigger('click')
      }
    })
    $contentTarget.on('hidden.bs.collapse.collapsedForm', () => {
      // Prevent UI from opening on next click
      $contentTarget.off(FOCUS_EVENTS)
    })

    this.toggle(event)
  }
}
